module.exports = __webpack_public_path__ + "static/media/news-image-2.3460d1da.png";